import { rgba } from "polished";
import styled, { css } from "styled-components";
import { SplideWrapper } from "../../../../../structures/others/slider/styled.js";
import Tabs from "../../../../../structures/others/tabs/index.js";
import { TabsButton, TabsCarouselItem, TabsCarouselList, TabsWrapper } from "../../../../../structures/others/tabs/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius, Padding } from "../../../../../../styles/common/mixins/logical.styled.js";
import { SearcherTabsVariant } from "../../types.js";
export const SearcherTabsTitle = styled.h1.withConfig({
    displayName: "styled__SearcherTabsTitle",
    componentId: "sc-73ef2051-0"
})`
	background-color: ${({ theme  })=>theme.colors.primary.base};
	color: ${({ theme  })=>theme.colors.white.base};
	text-align: center;
	${Padding({
    y: '12px',
    x: '16px'
})}
	${FontMixin({
    size: 'large',
    weight: 'medium',
    height: 'large'
})}
`;
const searcherTabsVariants = {
    default: css`
		${TabsButton} {
			${FlexMixin({
        direction: 'column',
        align: 'center',
        justify: 'center'
    })}
			${FontMixin({
        size: 'small',
        weight: 'regular',
        height: 'small'
    })}
			color: ${({ theme  })=>theme.colors.white.base};
			gap: 8px;

			&.is-active {
				color: ${({ theme  })=>theme.colors.secondary.base};
				border-color: currentColor;
			}

			i {
				${FontMixin({
        size: 'largest'
    })}
			}
		}
	`,
    buttons: css`
		a {
			color: ${({ theme  })=>rgba(theme.colors.white.base, 0.7)};
		}

		${TabsButton} {
			${BorderRadius({
        all: '4px'
    })}
			${FontMixin({
        size: 'small',
        weight: 'light',
        height: 'base'
    })}
		color: ${({ theme  })=>rgba(theme.colors.white.base, 0.7)};
			padding: 8px 12px;
			text-transform: none;
			border: 1px solid transparent;

			&.is-active {
				border: 1px solid ${({ theme  })=>theme.colors.white.base};
				color: ${({ theme  })=>theme.colors.white.base};
			}
		}

		${TabsWrapper} {
			border: 0px;
		}

		${TabsCarouselList} {
			padding: 16px 16px 0;
		}

		${TabsCarouselItem} {
			flex-grow: 1;
		}

		${SplideWrapper} {
			margin: 0;

			.splide__arrows {
				.splide__arrow {
					color: ${({ theme  })=>theme.colors.white.base};

					&:hover {
						color: ${({ theme  })=>theme.colors.primary.light};
					}
				}
			}
		}
	`
};
export const SearcherTabsTabsMobile = styled(Tabs).withConfig({
    displayName: "styled__SearcherTabsTabsMobile",
    componentId: "sc-73ef2051-1"
})`
	background-color: ${({ theme  })=>theme.colors.primary.base};
	border-radius: 0px;

	${TabsWrapper} {
		border: 0px;
	}

	${({ $variant  })=>searcherTabsVariants[$variant ?? SearcherTabsVariant.Default]}
`;

//# sourceMappingURL=styled.js.map